import { render, staticRenderFns } from "./SorteoNumerosDisponibles.vue?vue&type=template&id=2fb1e2ad&scoped=true&"
import script from "./SorteoNumerosDisponibles.vue?vue&type=script&lang=ts&"
export * from "./SorteoNumerosDisponibles.vue?vue&type=script&lang=ts&"
import style0 from "./SorteoNumerosDisponibles.vue?vue&type=style&index=0&id=2fb1e2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1e2ad",
  null
  
)

export default component.exports